import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

import { safeJsonInput } from '../../../shared/_utils/safe-json-input';
@Component({
    selector: 'gtw-cbc-reporting',
    templateUrl: './cbc-reporting.component.html',
    styleUrls: ['./cbc-reporting.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CbcReportingComponent {
  @Output('request-grid-update') requestGridUpdate = new EventEmitter<string>();

  private isInitialized = false;
  title = 'CBC Reporting';
  minimise = false;
  crudLoading = false;
  rows: any[] = [];
  tax_years: string[] = [];
  types = [
    { LABEL: 'Income Taxes', VALUE: 'Income Taxes' },
    { LABEL: 'W/H Taxes', VALUE: 'W/H Taxes' },
    { LABEL: 'Audit/Exam Payments', VALUE: 'Audit/Exam Payments' }
  ];

  baseURLs: any = {};
  headerData: any = {};
  rowData: any = {};
  filterParams: any = {};
  globalService: any = {};
  GENERAL_CONFIG: any = {};

  constructor(private cdr: ChangeDetectorRef) {}

  @Input('base-urls')
  set _base_urls(v: string) {
    try {
      const u = typeof v === 'string' ? safeJsonInput<any>(v, null, 'cbc-reporting.parse1') : v;
      if (u && Object.keys(u).length > 0) {
        this.baseURLs = u;
        this.tryInit();
      }
    } catch (_e) {}
  }

  @Input('header-data')
  set _header_data(v: string) {
    try {
      const h = typeof v === 'string' ? safeJsonInput<any>(v, null, 'cbc-reporting.parse2') : v;
      if (h && (h.globalParams || h.generalConfigData)) {
        this.globalService = h.globalParams || {};
        this.GENERAL_CONFIG = h.generalConfigData || {};
        this.tryInit();
      }
    } catch (_e) {}
  }

  @Input('row-data')
  set _row_data(v: string) {
    try {
      const r = typeof v === 'string' ? safeJsonInput<any>(v, null, 'cbc-reporting.parse3') : v;
      if (r) {
        this.rowData = r;
        this.tryInit();
      }
    } catch (_e) {}
  }

  @Input('filter-params')
  set _filter_params(v: string) {
    try {
      const p = typeof v === 'string' ? safeJsonInput<any>(v, null, 'cbc-reporting.parse4') : v;
      if (p && Object.keys(p).length > 0) {
        this.filterParams = p;
        this.tryInit();
      }
    } catch (_e) {}
  }

  private tryInit(): void {
    if (this.isInitialized) return;
    if (!this.globalService || !this.GENERAL_CONFIG) return;
    this.isInitialized = true;
    this.init();
  }

  init(): void {
    this.rows = Array.isArray(this.rowData?.rows) ? [...this.rowData.rows] : [];
    this.tax_years = this.filterParams?.tax_years || this.rowData?.tax_years || [];
    if (this.rows.length === 0) {
      this.addRow();
    }
    this.cdr.detectChanges();
  }

  cancel(): void {
    this.requestGridUpdate.emit('cancel');
  }

  save(): void {
    this.requestGridUpdate.emit('refresh');
  }

  addRow(): void {
    this.rows.push({
      PERIOD_NAME: '',
      TAX_YEAR: this.tax_years[0] || this.filterParams?.tax_year || '',
      TYPE: '',
      GOLD_ID: '',
      MARS_ID: '',
      IMPOSING_TAX_DESC: '',
      AMOUNT: 0
    });
    this.cdr.detectChanges();
  }

  removeRow(index: number): void {
    this.rows.splice(index, 1);
    if (this.rows.length === 0) this.addRow();
    this.cdr.detectChanges();
  }
}
